import { InputTargetNode, MessagingTopology } from '@internal/open-catalog';
import { Box, Grid, IconButton, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '../../../../../../components/accordion/accordion.styled';
import { usePanelEditableStyles } from './panel.style';
import { InputTargetDialog } from './dialog.input.target';

export function InputTargetPanel(props: {
  expanded: string | boolean,
  topology: MessagingTopology
  onAccordionStateChange: (panel: any) => (_event: ChangeEvent<{}>, isExpanded: boolean) => void,
  onTopologyChange: (newNodeName?: string) => void
}) {

  const { topology, expanded, onAccordionStateChange, onTopologyChange } = props;

  const classes = usePanelEditableStyles();

  const [targets, setTargets] = useState<InputTargetNode[]>([]);

  const [formDialog, setFormDialog] = useState(false);

  const openInputTargetFormDialog = (event: React.MouseEvent): void => {
    event.stopPropagation();
    setFormDialog(true);
  }

  const isDuplicatedInputTarget = (newQueue: InputTargetNode): boolean => {
    const found = topology.input?.targets.filter(q => q.name === newQueue.name);
    return (found || []).length > 0;
  }

  const closeInputTargetFormDialog = (newQueue?: InputTargetNode): void => {
    if (newQueue && !isDuplicatedInputTarget(newQueue)) {
      topology.input?.targets.unshift(newQueue);
      onTopologyChange(newQueue.name);
    }
    setFormDialog(false);
  }

  const removeInputTarget = (index: number): void => {
    topology.input?.targets.splice(index, 1);
    onTopologyChange();
  };

  useEffect(() => {
    setTargets(topology.input?.targets || []);
  }, [topology]);

  return (<>
    {topology.input && (
      <InputTargetDialog open={formDialog} source={topology.input} onClose={closeInputTargetFormDialog} />
    )}
    <Accordion expanded={expanded === 'targets'} onChange={onAccordionStateChange('targets')}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <ListItem className={classes.headerWithActions}>
          <ListItemText primary="Targets" />
          <IconButton edge="start" color='secondary' size="small" title="Create new internal queue to delivery messages." onClick={openInputTargetFormDialog}>
            <AddIcon />
          </IconButton>
        </ListItem>
      </AccordionSummary>
      <AccordionDetails>

        {!targets.length && (
          <Typography variant='caption' component="p">No target queues defined, let's add some ! :D</Typography>
        )}

        {targets.length > 0 && (
          <Grid container spacing={1} className={classes.root}>
            {targets.map((t, index) => (
              <Grid key={index} item xs={12}>
                <Box className={classes.group}>
                  <List dense className={classes.list}>
                    <ListItem>
                      <ListItemText primary={t.name} secondary={t.type} title={t.name} />
                      <IconButton edge="start" size="small" title="Remove queue" onClick={() => removeInputTarget(index)}>
                        <DeleteForeverIcon />
                      </IconButton>
                    </ListItem>
                  </List>
                </Box>
              </Grid>
            ))}
          </Grid>
        )}
      </AccordionDetails>
    </Accordion>
  </>);
};